import Immutable from 'immutable';
import { OFFSET } from '../../utils/constants';

const LOAD = 'phoneBookData/LOAD';
const LOAD_SUCCESS = 'phoneBookData/LOAD_SUCCESS';
const LOAD_ADD_SUCCESS = 'phoneBookData/LOAD_ADD_SUCCESS';
const LOAD_FAIL = 'phoneBookData/LOAD_FAIL';
const LOAD_UPDATE_SUCCESS = 'phoneBookData/LOAD_UPDATE_SUCCESS';
const LOAD_DATA_SUCCESS = 'phoneBookData/LOAD_DATA_SUCCESS';

const initialState = Immutable.fromJS({
  phoneBookData: null,
  loading: false,
  errorMessage: null,
  activePage: 1
});

export default function reducer(state = initialState, action) {
  switch (action.type) {

    case LOAD:
    return state
    .set('loading', true);

    case LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('activePage', action.page)
    .set('phoneBookData', action.phoneBookData);

    case LOAD_ADD_SUCCESS:
    return state
    .set('loading', false)
    .set('phoneBookData', action.result);


    case LOAD_UPDATE_SUCCESS:
    return state
    .set('loading', false)
    .set('phoneBookData', action.phoneBookData);

    case LOAD_DATA_SUCCESS:
    return state
    .set('loading', false)

    default:
    return state;
  }
}




export const getPhoneBookData = (offset, page) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get(`/PhoneBookData/all/${offset}`);
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_SUCCESS, phoneBookData: res, page });

  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const addPhoneBookData = (data) => async (dispatch, getState, api) => {
  const phoneBookData = getState().get('phoneBookData').get('phoneBookData');
  let page = Math.ceil(phoneBookData.count / OFFSET);
  if (phoneBookData.count % OFFSET === 0) {
    page = page + 1;
  }
  let offset = OFFSET * (page - 1)
  dispatch({ type: LOAD });
  try {
    const res = await api.post('/PhoneBookData/', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch(getPhoneBookData(offset, page));
    dispatch({ type: LOAD_ADD_SUCCESS, result: res });
    return res;

  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};


export const updatePhoneBookData = (data) => async (dispatch, getState, api) => {
   dispatch({ type: LOAD });
   let initialPhoneBookData = getState().get('phoneBookData').get('phoneBookData');
   let page = getState().get('phoneBookData').get('activePage');
   let offset = OFFSET * (page - 1);
  try {
    const res = await api.put('/PhoneBookData/', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    let updatedPhoneBookData = initialPhoneBookData.rows.filter(function(PhoneData) {
      return PhoneData.id !== data.id
    });
    let updatedPhoneData = {
      rows: updatedPhoneBookData,
      count: initialPhoneBookData.count
    }
    dispatch({ type: LOAD_UPDATE_SUCCESS, phoneBookData: updatedPhoneData });
    dispatch(getPhoneBookData(offset, page));
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const deletePhoneBookData = (data, offset) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  let initialPhoneBookData = getState().get('phoneBookData').get('phoneBookData');
  let page = getState().get('phoneBookData').get('activePage');
  try {
    const res = await api.del('/PhoneBookData/', {data});
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    let updatedPhoneBookData = initialPhoneBookData.rows.filter(function(Data) {
      return Data.id !== data.id
    });
    let updatedPhoneData = {
      rows: updatedPhoneBookData,
      count: initialPhoneBookData.count
    }
    dispatch({ type: LOAD_UPDATE_SUCCESS, phoneBookData: updatedPhoneData });
      dispatch(getPhoneBookData(offset, page));
    } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const getPhoneBookDataById = (id) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/PhoneBookData/'+id );
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_DATA_SUCCESS });
    return res ;

  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};



// WEBPACK FOOTER //
// ./src/redux/modules/phoneBookData.js